
 export const MSG_ERRORS = {
	primary_unique : "PRIMARY must be unique",
	slot_not_available : "SLOT not available",
	qr_already_generated : "ORDER NUMBER QR already generated for today",
	order_not_available : "ORDER not available",
	error_transportista: "ERROR_TRANSPORTISTA",
    msg_prevision_already_exists : "Esta previsión ya ha sido generada", 
	msg_slot_not_available : "No existen slots disponibles para esta fecha", 
	msg_order_not_found: "Pedido no encontrado",
	msg_qr_already_generated : "Numero de pedido ya generado para el día de hoy", 
	msg_order_not_available : "No se dispone de información sobre este pedido",
	msg_generic_error : "Ha cocurrido un error creando la previsión",
	msg_slots_error : "Error creando o consultando slots",
	msg_wrong_status_transport:"Número Transporte se encuentra en un estado incorrecto",
	msg_error_getting_prevision: "Error obteniendo la prevision desde la Base de datos",
	msg_error_transportista: "El transportista no existe o es incorrecto",
	msg_error_mmat_restriction: "Es necesaria homologación para MMA de 44T",
	
 }